import React from "react";

import { AccountType } from "../../utils/constants";
import { BrokeredAccountIcon, InternalAccountIcon } from "./iconography";

export const AccountTypeIcon = ({ account, ml = 0, mt = 0 }) => {
  if (account?.accountType === AccountType.BROKERED) {
    return <BrokeredAccountIcon ml={ml} mt={mt} />;
  }
  if (account?.accountType === AccountType.INTERNAL) {
    return <InternalAccountIcon ml={ml} mt={mt} />;
  }
  return null;
};
